import axios from "axios";
import { UploadUrlResponse, PhotosResponse } from "../types";

const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const photoService = {
  getPhotos: async (
    limit: number = 12,
    offset: number = 0
  ): Promise<PhotosResponse> => {
    const response = await api.get(`/photos?limit=${limit}&offset=${offset}`);
    return response.data;
  },

  getUploadUrl: async (
    file: File,
    uploadedBy: string,
    signal?: AbortSignal
  ): Promise<UploadUrlResponse> => {
    const response = await api.post(
      "/upload-url",
      {
        filename: file.name,
        contentType: file.type,
        uploaded_by: uploadedBy,
      },
      { signal }
    );

    return response.data;
  },

  uploadToS3: async (
    file: File,
    uploadUrl: string,
    fields: Record<string, string>,
    signal?: AbortSignal
  ): Promise<void> => {
    const formData = new FormData();

    Object.entries(fields).forEach(([key, value]) => {
      formData.append(key, value);
    });

    formData.append("file", file);

    const response = await fetch(uploadUrl, {
      method: "POST",
      body: formData,
      signal,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `S3 upload failed: ${response.status} ${response.statusText} - ${errorText}`
      );
    }
  },

  completeUpload: async (
    key: string,
    uploadedBy: string,
    signal?: AbortSignal
  ): Promise<void> => {
    const response = await api.post(
      "/upload-complete",
      {
        key,
        uploaded_by: uploadedBy,
      },
      { signal }
    );

    if (response.status !== 204) {
      throw new Error(
        `Upload completion failed: ${response.status} ${response.statusText}`
      );
    }
  },
};

export default api;
